import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import * as serviceWorker from './serviceWorker';
import * as firebase from 'firebase/app';
import 'firebase/database';

import { App } from './components/App';

import { UserName } from './containers/UserName';
import { UserId } from './containers/UserId';
import { Console } from './containers/Console';

const firebaseConfig = {
    apiKey: 'AIzaSyCMBgKl3You8VSdM06Dcz8KVvZ98eog9c4',
    authDomain: 'bananagrams-d4dc7.firebaseapp.com',
    databaseURL: 'https://bananagrams-d4dc7.firebaseio.com',
    projectId: 'bananagrams-d4dc7',
    storageBucket: 'bananagrams-d4dc7.appspot.com',
    messagingSenderId: '510587671030',
    appId: '1:510587671030:web:ebe64ab9fdf44824f937d7',
    measurementId: 'G-RSFRH488DH',
};

firebase.initializeApp(firebaseConfig);
//firebase.database.enableLogging(true);

//
// rooms/id
// * users
//      * name
//      * id
// * commands

ReactDOM.render(
    <React.StrictMode>
        <Console.Provider>
            <UserId.Provider>
                <UserName.Provider>
                    <App />
                </UserName.Provider>
            </UserId.Provider>
        </Console.Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

